
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlT as ObiOwnShipControlTElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-t.js';
 
 
 

 
 export const ObiOwnShipControlT = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-t',
   elementClass: ObiOwnShipControlTElement,
   events: {
     
   }
  });
 
 